module.exports = __webpack_public_path__ + "img/track-and-trace.921e2df4.png";